import { Component, Event, EventEmitter, h, Prop } from '@stencil/core';
import { Location } from '~model/location';
import { translate } from '~service/translation-service';

declare const google: any;

@Component({
  tag: 'uvex-location-pin',
  styleUrl: 'location-pin.scss',
})
export class LocationPin {
  @Prop()
  location: Location;

  @Prop()
  active: boolean = false;

  @Event()
  mapsClick: EventEmitter<Location>;

  @Event()
  mapsInfoWindowOpen: EventEmitter<Location>;

  @Event()
  mapsInfoWindowClose: EventEmitter<Location>;

  render() {
    const location = this.location;
    const infoWindow = this.active ? this.renderInfoWindow() : null;

    return (
      <uvex-google-map-marker
        latitude={location.latitude}
        longitude={location.longitude}
        showInfoWindow={!!infoWindow}
        icon={location.icon}
        zIndex={this.active ? google.maps.Marker.MAX_ZINDEX - 1 : null}
        onMapsInfoWindowOpen={_ => this.mapsInfoWindowOpen.emit(location)}
        onMapsClick={_ => this.mapsClick.emit(location)}
        onMapsInfoWindowClose={_ => this.mapsInfoWindowClose.emit(location)}
      >
        {infoWindow}
      </uvex-google-map-marker>
    );
  }

  private renderInfoWindow() {
    const location = this.location;
    return (
      <div>
        <h4>
          <span>{location.companyName}</span>
        </h4>
        <p>
          {location.phone && (
            <span>
              <strong>T</strong> {location.phone}
              <br />
            </span>
          )}
          {location.fax && (
            <span>
              <strong>F</strong> {location.fax}
              <br />
            </span>
          )}
          {location.email && (
            <span>
              <strong>E</strong> <a href={'mailto:' + location.email}>{location.email}</a>
              <br />
            </span>
          )}
          <a class="jump-link" href={'#c' + location.id}>
            {translate('more-details')}
          </a>
        </p>
      </div>
    );
  }
}
